"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function act(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.3275 5.25H13.6725C13.7884 5.24994 13.9022 5.28076 14.0023 5.33929C14.1023 5.39781 14.185 5.48194 14.2417 5.583L19.4212 14.8223C19.4758 14.9196 19.5044 15.0294 19.5044 15.141C19.5044 15.2526 19.4758 15.3624 19.4212 15.4598L17.7637 18.4163C17.7071 18.5173 17.6247 18.6015 17.5247 18.6602C17.4248 18.7189 17.3111 18.7498 17.1952 18.75H6.80474C6.68876 18.75 6.57488 18.7191 6.47482 18.6604C6.37476 18.6017 6.29215 18.5175 6.23549 18.4163L4.57874 15.4598C4.52422 15.3624 4.49559 15.2526 4.49559 15.141C4.49559 15.0294 4.52422 14.9196 4.57874 14.8223L9.75824 5.583C9.815 5.48194 9.89765 5.39781 9.9977 5.33929C10.0978 5.28076 10.2116 5.24994 10.3275 5.25ZM12 8.92575L8.51024 15.141H15.4897L12 8.92575Z", fill: color }));
}
exports["default"] = act;
//# sourceMappingURL=act.js.map